const component = "user-perimeter-tree";

export const userPerimeterTree = {
  component,
  mainCheckbox: `${component}/main-checkbox`,
  disabledCheckbox: `${component}/disabled-checkbox`,
};
